import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'
import {FormGroup} from '@angular/forms'

@Component({
  selector: 'dmmp-form-text-area',
  templateUrl: './textArea.component.html',
})
export class TextAreaComponent implements OnInit {
  @Input() field
  @Input() fieldData
  @Input() identifier
  @Input() group: FormGroup
  @Output() changeValueInput: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit() {
  }
}
